@if (displaySystemInfo) {
  <div class="container">
    <div>
      User Id: {{userId}}
    </div>
    <div>
      User Name: {{userName}}
    </div>
    <div>
      Application Insights Key: {{applicationInsightsId}}
    </div>
  </div>
}